import { Asset } from "../models/asset";
import { ITruckerPayPlanData } from "../models/truckerPayPlan";
import { IContractDetailsVolksEssential } from "../models/volksPlanEssential";

import ApiService from "../services/api";
import { PlanStatusEnum } from "../enums/plan";

export const fetchContractDetails = async (
  asset: Asset,
): Promise<ITruckerPayPlanData> => {
  const apiService = new ApiService();

  const params = new URLSearchParams();
  if (asset.odometer > 0) params.append("odometer", String(asset.odometer));
  if (asset.hourmeter > 0) params.append("hourMeter", String(asset.hourmeter));

  const response = await apiService.get<ITruckerPayPlanData>(
    `/assets/${asset.chassis}/trucker-pay-plan?${params.toString()}`,
  );
  if (response.status !== 200 || !response.data) {
    throw new Error("Erro ao buscar detalhes do contrato");
  }
  return response.data;
};

export const fetchVolksEssentialsContractDetails = async ({
  chassis,
  id,
  contract,
}: {
  chassis?: String;
  id?: number;
  contract?: string;
}): Promise<IContractDetailsVolksEssential> => {
  if (!chassis && !id && !contract) {
    throw new Error("Chassis, ID ou contrato é obrigatório");
  }

  const apiService = new ApiService();

  let url = `/assets/${chassis}/volks-essentials-plan`;
  if (id) url = `/plans/volks-essentials/${id}`;
  if (contract) url = `/plans/volks-essentials/contract/${contract}`;

  const response = await apiService.get<IContractDetailsVolksEssential>(url);
  if (response.status !== 200 || !response.data) {
    throw new Error("Erro ao buscar detalhes do contrato");
  }
  
  return {
    ...response.data,
    contractStatus: PlanStatusEnum[(response.data.contractStatus ?? 'UNKNOWN') as keyof typeof PlanStatusEnum],
  };
};
